import React from "react";
import "../../../css/loaders.css";
import PropTypes from "prop-types";

function SkeletonLoader({ width }) {
  return (
    <React.Fragment>
      <span className='skeleton-loader m-2' style={{ width }}></span>
    </React.Fragment>
  );
}

SkeletonLoader.propTypes = {
  /** Option Value = 'x%' */
  width: PropTypes.string
};

export default SkeletonLoader;
